module.exports = __webpack_public_path__ + "static/img/WechatIMG475.b33bc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatIMG475.jpg
// module id = G2hj
// module chunks = 1